import { createFileRoute } from '@tanstack/react-router';
import { ItemListPage } from '@/components/item-list';

export const Route = createFileRoute('/sales/products-and-services/')({
  component: ItemListPage,
});
